import React, { memo, useCallback, useMemo, useState } from 'react'
import { Dropdown, Tooltip } from 'antd'
import { useSelector } from 'react-redux'
import QueueStats from 'components/apps/Notification/QueueStats'
import Timeline from 'containers/Notification/Timeline'
import { useResponsive } from 'utils/hooks'
import { darkModeSelector } from 'app-redux/selectors'
import { compareWithJSON } from 'utils/helper'
import { useIntl } from 'react-intl'
import styles from './style.module.scss'

const ICON_BASE = 'resources/images/icons/menu-v2'

const Timelines = () => {
  const { formatMessage } = useIntl()
  const [visible, setVisible] = useState(false)
  const darkMode = useSelector(darkModeSelector)

  const { isMobileView } = useResponsive()

  const visibleChangeHandler = (flag) => setVisible(flag)
  const hideHandler = () => setVisible(false)

  const stylePane = useMemo(() => {
    const style = { height: 400, overflow: 'auto' }

    if (!isMobileView) {
      style.width = 400
    }

    return style
  }, [isMobileView])

  const renderDropdownMenu = useCallback(() => {
    return (
      <div
        className={`card cui__utils__shadow width-350 overflow-hidden border-0 ${
          darkMode ? 'bg-dark-3 text-light' : 'bg-light'
        }`}
      >
        <div style={stylePane}>
          <QueueStats enabled={visible} />
          <Timeline isMobileView={isMobileView} onHideParent={hideHandler} />
        </div>
      </div>
    )
  }, [darkMode, isMobileView, stylePane, visible])
  return (
    <Tooltip
      open={visible ? false : undefined}
      title={formatMessage({ id: 'topBar.dataChangesTimeline' })}
    >
      <div className={styles.trigger}>
        <Dropdown
          popupRender={renderDropdownMenu}
          trigger={['click']}
          placement="bottomRight"
          open={visible}
          arrow
          onOpenChange={visibleChangeHandler}
          destroyOnHidden
        >
          <div className={`${styles.dropdown} ${visible ? styles.open : ''}`}>
            <span className={styles.illus}>
              <img src={`${ICON_BASE}/history.svg`} alt="" />
            </span>
          </div>
        </Dropdown>
      </div>
    </Tooltip>
  )
}

export default memo(Timelines, compareWithJSON)
